import router from '../router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import cookie from '@/api/cookie';
import store from '@/store';
const config = require('../../config');

NProgress.configure({ showSpinner: false });

let whiteList = ['/login', '/error/404']; //白名单，不校验登录

//鹰眼主入口白名单
if (config.WEB == 6) {
  whiteList = whiteList.concat(['/index', '/index-rj', '/index-xh', '/index-about', '/map']);
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  // 微信OAuth回调会带 ?token=xxx 跳回(如 /login 或 /map 等白名单页面),
  // 必须先于白名单判断保存 token, 否则白名单页面直接放行导致 token 丢失、登录死循环
	const callbackToken = to.query.token || to.query['xx-token'];
	if (callbackToken) {
		cookie.setToken(callbackToken);
		store.commit('user/SET_TOKEN', callbackToken);
		delete to.query.token;
		delete to.query['xx-token'];
  }

  if (whiteList.filter((item) => item == to.path || item + '/' == to.path).length) {
    next();
    return;
  }

  const hasToken = cookie.getToken();
  const isMobile = window.innerWidth <= 1024;
  if (config.WEB != 1) {
    let loginStatus = store.state.user.loginStatus;
    if (!loginStatus) {
      loginStatus = await store.dispatch('user/updateLoginStatus');
    }
    if (hasToken && loginStatus == 3) {
      // 电脑端保持原行为(微信游客未绑手机 -> 回登录页); 手机端游客直接放行, 不闪二维码页
      if (!isMobile) {
        window.location.href = `${config.API_BASE}/login`;
        return;
      }
    }
  }

  const alreayGeneraterMenus = store.getters.alreayGeneraterMenus;

  if (hasToken && alreayGeneraterMenus) {
    next();
    return;
  }

  if (hasToken) {
    let userInfo;
    try {
      userInfo = await store.dispatch('user/getUserInfo');
    } catch (e) {
      // token 失效: 手机端清除后放行(微信会重新静默登录), 电脑端回登录页
      cookie.removeToken();
      store.commit('user/SET_TOKEN', '');
      if (!isMobile) {
        next('/login');
        return;
      }
      next({ ...to, replace: true });
      return;
    }
    if (userInfo.has_auth == 2) {
      store.commit('router/UPDATE_MENUS_STATUS', true);
      next({ path: '/no-auth', replace: true });
      return;
    }

    //user_type = 2 运营方
    if (userInfo.user_type == 2) {
      const menus = await store.dispatch('user/getMenus');
      if (userInfo.level == 3) {
        menus.find((item) => item.path.includes('/city')).is_show = 2;
        menus.find((item) => item.path.includes('/permission-account')).is_show = 2;
      }
      const accessRoutes = await store.dispatch('router/generateRoutes', menus);
      router.addRoutes(accessRoutes);
    } else {
      store.commit('router/UPDATE_MENUS_STATUS', true);
    }
    next({ ...to, replace: true });
    return;
  }

  if (!hasToken) {
    if (config.WEB == 1 || process.env.NODE_ENV == 'development') {
      next('/login');
    } else if (isMobile) {
      // ===== 手机端: 不跳二维码登录页 =====
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        // 微信内置浏览器: 静默登录(snsapi_base, 无授权确认页), 全程无感
        // forward 必须用 window.location.pathname(含 BASE_URL 前缀, 如 /rj/front-vr-list),
        // 不能用 to.fullPath(路由内路径无前缀), 否则 OAuth 回调会跳到错误路径(如跳回 yy 主站)
        const forward = `${window.location.pathname}${window.location.search}`;
        window.location.href = `${config.API_BASE}/api/user/weixinSilentLogin?forward=${encodeURIComponent(forward)}`;
        return;
      }
      // 非微信浏览器: 直接放行, 页面显示加载中(不跳二维码登录页)
      next();
    } else {
      // ===== 电脑端: 保持原行为 =====
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        // 微信内置浏览器: 直接发起微信OAuth, 跳过二维码登录页(避免先闪二维码页面再跳转)
        const forward = `${window.location.pathname}${window.location.search}`;
        window.location.href = `${config.API_BASE}/api/user/weixinLogin?forward=${encodeURIComponent(forward)}`;
        return;
      }
      window.location.href = `${config.API_BASE}/login`;
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
